<!-- 游戏头部 -->
<template>
    <header id="nheader" class="noshowforgame page-header">
        <button class="js-canvi-open-button--right menu"></button>
        <a href="" class="logo" target="_top">掌域</a>
        <a href="javascript:void(0)" title="页游" onClick="gotobbspc();" class="fr butn">
            <i class="zico z-menu-ec"></i>
        </a>
    </header>
</template>
<style>
/* 头部导航 */
.page-header {
    height: 50px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 15px;

    .logo {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 150px;
        height: 23px;
        background: url("/img/login/logo_6.png") no-repeat center;
        background-size: contain;
        text-indent: -9999px;
    }
}
</style>
<script>
import { reactive, toRefs, onMounted } from "vue";
import { useStore } from 'vuex';
import { useRouter } from "vue-router";

export default {
    setup(props, context) {
        const store = useStore();
        const router = useRouter();
        onMounted(() => {
            //登录判断
            alreadyLogged();
        });

        const state = reactive({
            loginState: false
        });

        const login = () => {
            store.commit("setNeedLogin", true);
        }
        const skipUserCenter = () => {
            goTo("/my", {});
        }
        //判断是否已登录
        const alreadyLogged = () => {
            var isLogin = store.getters.isLogin;
            state.loginState = isLogin ? false : true;
        }
        const goTo = (url, params) => {
            router.push({ path: url, query: params })
        }
        //跳转到主页
        const skipHome = () => {
            console.log(context)
            context.emit('skip-page', {});//隐藏掉暂停按钮
        }
        return {
            ...toRefs(state),
            login,
            skipUserCenter,
            skipHome
        };
    }
}
</script>